import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { RefreshCw, AlertTriangle } from 'lucide-react';
import { useTranslation } from "react-i18next";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-4">
        <Alert variant="destructive">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>{t("errorFallback.title")}</AlertTitle>
          <AlertDescription>
            {t("errorFallback.description")}
          </AlertDescription>
        </Alert>

        <div className="bg-card border rounded-lg p-4">
          <h3 className="font-semibold text-sm text-muted-foreground mb-2">
            {t("errorFallback.details")}:
          </h3>
          <p className="text-sm text-foreground font-mono bg-muted p-2 rounded">
            {error.message}
          </p>
        </div>

        <Button 
          onClick={resetErrorBoundary}
          variant="outline"
          className="w-full"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          {t("errorFallback.tryAgain")}
        </Button>
      </div>
    </div>
  );
}